import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  ReactNode,
} from 'react';

const ShopPayContext = createContext<{
  isShopPaySessionCreated: boolean;
  setIsShopPaySessionCreated: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  isShopPaySessionCreated: false,
  setIsShopPaySessionCreated: () => {
    throw Error('setIsShopPaySessionCreated not initialized');
  },
});

export const ShopPayProvider = ({ children }: { children: ReactNode }) => {
  const [isShopPaySessionCreated, setIsShopPaySessionCreated] =
    useState<boolean>(false);

  const shopPayValue = useMemo(
    () => ({
      isShopPaySessionCreated,
      setIsShopPaySessionCreated,
    }),
    [isShopPaySessionCreated],
  );

  return (
    <ShopPayContext.Provider value={shopPayValue}>
      {children}
    </ShopPayContext.Provider>
  );
};

export const useShopPayContext = () => useContext(ShopPayContext);
